import { PermissionLevel } from '../permissions/permission-levels.enum';

export abstract class BaseComponent {
  PermissionLevel = PermissionLevel;
}
